import { useQuery } from '@tanstack/react-query';
import { usersClient } from 'clients/UsersClient/UsersClient';
import { useContext } from 'react';
import { AuthContext } from 'shared/legacy/contexts/AuthContext';
import { UserContext } from 'shared/legacy/contexts/UserContext/UserContext';
import { sendIndeedConfig } from 'shared/legacy/hooks/useBrowserExtension/indeed/sendIndeedConfig';
import { QueryKey } from 'types/query';

export const useRefreshToken = () => {
  const { setUserToken, activeTokenType, setImpersonateToken, activeToken } = useContext(AuthContext);
  const { isLoggedIn } = useContext(UserContext);
  useQuery(
    [QueryKey.useRefreshToken],
    async () => {
      if (!isLoggedIn) {
        return null;
      }

      const response = await usersClient.refreshToken();
      return response.data;
    },
    {
      enabled: isLoggedIn,
      refetchInterval: 20 * 60 * 1000,
      refetchOnWindowFocus: true,
      refetchIntervalInBackground: false,
      retry: 1,
      onSuccess: (data) => {
        if (data?.access_token && isLoggedIn && activeToken) {
          if (activeTokenType === 'impersonate') {
            setImpersonateToken(data.access_token);
          } else {
            setUserToken(data.access_token);
          }

          sendIndeedConfig();
        }
      },
      onError: (error) => {
        console.error('Failed to refresh token:', error);
      },
    },
  );
};
